import React, { Component } from "react";

class AddItemButton extends Component {
    render() {
        return (<div className="form-row">
            <div className="col-1 text-center">
                <a className="add btn btn-sm btn-light" onClick={this.props.addItem}>+</a>
            </div>
        </div>);
    }
}

export default AddItemButton;




// WEBPACK FOOTER //
// ./src/components/AddItemButton.js